import { render, staticRenderFns } from "./dictList.vue?vue&type=template&id=2efa0ab8&scoped=true"
import script from "./dictList.vue?vue&type=script&lang=js"
export * from "./dictList.vue?vue&type=script&lang=js"
import style0 from "./dictList.vue?vue&type=style&index=0&id=2efa0ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efa0ab8",
  null
  
)

export default component.exports